import { editUserName } from "@/apis/user";
import { useUserInfoStore } from "@/stores/userInfo";
import { Form, Toast } from "antd-mobile";
import { useNavigate } from "react-router-dom";

export const useLogic = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useUserInfoStore()((state) => [
    state.userInfo,
    state.setUserInfo,
  ]);
  const saveData = async () => {
    const userName = form.getFieldValue("userName") || "";
    if (userName.length < 4 || userName.length > 20) {
      return Toast.show("用户名为4-20位字符");
    }

    const { ok, msg } = await editUserName({
      userName: userName,
    });

    if (ok) {
      setUserInfo({
        userName,
        isUserName: 1,
      });
      Toast.show(msg);
      navigate(-1);
    } else {
      Toast.show(msg);
    }
  };
  return {
    userInfo,
    form,
    saveData,
  };
};
